import * as React from 'react';
import * as paths from '../paths';
import locales from '../locales';
import ClientsPage from '../client/ClientsPage';
import ItemsPage from '../item/ItemsPage';
import RentalsPage from '../rental/RentalsPage';
import RentalSummaryPage from '../summary/RentalSummaryPage';
import RevenueSummaryPage from '../summary/RevenueSummaryPage';
import ClientRevenueSummaryPage from '../summary/ClientRevenueSummaryPage';
import {Route, RouteComponentProps, Switch, withRouter} from 'react-router';
import LoginPage from '../account/LoginPage';
import ItemDetailsPage from '../item-details/ItemDetailsPage';
import CreateItemPage from '../item-details/CreateItemPage';
import ClientDetailsPage from '../client-details/ClientDetailsPage';
import CreateClientPage from '../client-details/CreateClientPage';
import CreateRentalPage from '../rental-details/CreateRentalPage';
import RentalDetailsPage from '../rental-details/RentalDetailsPage';
import CreateReturnPage from '../return-details/CreateReturnPage';
import ReturnDetailsPage from '../return-details/ReturnDetailsPage';
import ClientSummaryPage from '../summary/ClientRentalSummaryPage';
import AlertsPage from "../alerts/AlertsPage";
import Page404 from '../Page404';
import accountProvider, {Role} from '../account/AccountProvider';
import {Action, Location, LocationListener, UnregisterCallback} from 'history';
import CategoryStatisticsPage from "../statistics/CategoryStatisticsPage";
import OverallStatisticsPage from "../statistics/OverallStatisticsPage";
import IncomingInvoicesPage from '../incoming-invoices/IncomingInvoicesPage';
import IncomingInvoiceStatisticsPage from '../statistics/IncomingInvoiceStatisticsPage';
import CreateIncomingInvoicePage from '../incoming-invoices/details/CreateIncomingInvoicePage';
import IncomingInvoiceDetailsPage from '../incoming-invoices/details/IncomingInvoiceDetailsPage';
import MaintenanceSheetsPage from "../maintenance/MaintenanceSheetsPage";
import CalendarPage from "../event/EventsPage";
import CreateEventPage from "../event-details/CreateEventPage";
import EventDetailsPage from "../event-details/EventDetailsPage";
import ChecklistAlertsPage from "../checklist-alerts/ChecklistAlertsPage";
import CreateChecklistPage from "../checklist/CreateChecklistPage";
import ChecklistDetailsPage from "../checklist/ChecklistDetailsPage";
import SendRentalChecklistsPage from "../checklist/send/SendRentalChecklistsPage";
import SendReturnalChecklistsPage from "../checklist/send/SendReturnalChecklistsPage";
import EventAlertsPage from "../event-alerts/EventAlertsPage";
import ClientCalendarPage from "../client-calendar/ClientCalendarPage";
import SendReturnalDocumentsPage from "../document-sendout/SendReturnalDocumentsPage";
import SendRentalDocumentsPage from "../document-sendout/SendRentalDocumentsPage";
import UserManagementPage from "../user-management/UserManagementPage";
import WarehousesPage from "../warehouse/WarehousesPage";
import InventoryStocksPage from "../inventory-stock/InventoryStocksPage";
import InventoryStockDetailsPage from "../inventory-stock-details/InventoryStockDetailsPage";
import CreateInventoryStockItemPage from "../inventory-stock-details/CreateInventoryStockItemPage";
import MaintenanceHistoryDetailsPage from "../maintenance/MaintenanceHistoryDetailsPage";
import CreateMaintenanceHistoryPage from "../maintenance/CreateMaintenanceHistoryPage";
import InventoryTransportLettersPage from "../inventory-transport-letters/InventoryTransportLettersPage";
import InventoryTransportLetterDetailsPage from "../inventory-transport-letters/InventoryTransportLetterDetailsPage";
import CreateInventoryTransportLetterPage from "../inventory-transport-letters/CreateInventoryTransportLetterPage";
import SalesPage from "../sales/SalesPage";
import CreateSalePage from "../sales/CreateSalePage";
import SaleDetailsPage from "../sales/SaleDetailsPage";
import CreateInvoicePage from "../invoicing/CreateInvoicePage";
import InvoicesPage from "../invoicing/InvoicesPage";
import ClientInvoicesPage from "../invoicing/ClientInvoicesPage";
import InvoiceDetailsPage from "../invoicing/InvoiceDetailsPage";

export interface MenuRoute {
  path: string;
  name: string;
  icon: string;
  component: any;
  subMenus?: MenuRoute[];
  allowedRoles: Role[]
}

const appMenuRoutes: MenuRoute[] = [{
  path: paths.clientsPath,
  name: locales.clients,
  icon: 'user',
  component: ClientsPage,
  allowedRoles: [Role.ADMIN, Role.MAINTENANCE, Role.SALES],
}, {
  path: paths.itemsPath,
  name: locales.items,
  icon: 'tool',
  component: ItemsPage,
  allowedRoles: [Role.ADMIN, Role.MAINTENANCE, Role.SALES],
}, {
  path: paths.rentalsPath,
  name: locales.rentals,
  icon: 'upload',
  component: RentalsPage,
  allowedRoles: [Role.ADMIN, Role.SALES],
}, {
  path: paths.summariesPath,
  name: locales.summaries,
  icon: 'table',
  component: RentalSummaryPage,
  allowedRoles: [Role.ADMIN, Role.SALES],
}, {
  path: paths.revenueSummaryPath,
  name: locales.revenue_summary,
  icon: 'table',
  component: RevenueSummaryPage,
  allowedRoles: [Role.ADMIN],
}, {
  path: paths.incomingInvoicesPath,
  name: locales.incoming_invoices,
  icon: 'credit-card',
  component: IncomingInvoicesPage,
  allowedRoles: [Role.ADMIN],
}, {
  path: paths.invoicesPath,
  name: locales.invoices,
  icon: 'file-text',
  component: InvoicesPage,
  allowedRoles: [Role.ADMIN],
}, {
  path: paths.alertsPath,
  name: locales.alerts,
  icon: 'warning',
  component: AlertsPage,
  allowedRoles: [Role.ADMIN],
}, {
  path: paths.maintenancesPath,
  name: locales.maintenance,
  icon: 'snippets',
  component: MaintenanceSheetsPage,
  allowedRoles: [Role.ADMIN, Role.MAINTENANCE, Role.SALES],
}, {
  path: paths.checklistAlertsPath,
  name: locales.checklist_alerts,
  icon: 'file-done',
  component: ChecklistAlertsPage,
  allowedRoles: [Role.ADMIN, Role.MAINTENANCE, Role.SALES],
}, {
  path: paths.statsPath,
  name: locales.statistics,
  icon: 'area-chart',
  component: null,
  allowedRoles: [Role.ADMIN, Role.SALES],
  subMenus: [{
    path: paths.categoryStatsPath,
    name: locales.item_categories,
    icon: 'pie-chart',
    component: CategoryStatisticsPage,
    allowedRoles: [Role.ADMIN, Role.SALES],
  }, {
    path: paths.incomingInvoiceStatsPath,
    name: locales.incoming_invoices,
    icon: 'pie-chart',
    component: IncomingInvoiceStatisticsPage,
    allowedRoles: [Role.ADMIN],
  }, {
    path: paths.overallStatsPath,
    name: locales.overall,
    icon: 'pie-chart',
    component: OverallStatisticsPage,
    allowedRoles: [Role.ADMIN, Role.SALES],
  }],
}, {
  path: paths.eventsPath,
  name: locales.event_calendar,
  icon: 'calendar',
  component: CalendarPage,
  allowedRoles: [Role.ADMIN, Role.SALES],
}, {
  path: paths.eventAlertsPath,
  name: locales.event_alerts,
  icon: 'schedule',
  component: EventAlertsPage,
  allowedRoles: [Role.ADMIN, Role.SALES],
}, {
  path: paths.userManagementPath,
  name: locales.user_management,
  icon: 'user',
  component: UserManagementPage,
  allowedRoles: [Role.ADMIN],
},
  {
    path: paths.inventoryPath,
    name: locales.inventory,
    icon: 'container',
    component: null,
    allowedRoles: [Role.ADMIN],
    subMenus: [
      {
        path: paths.warehousesPath,
        name: locales.warehouses,
        icon: 'shop',
        component: WarehousesPage,
        allowedRoles: [Role.ADMIN],
      }, {
        path: paths.inventoryStocksPath,
        name: locales.inventory_stocks,
        icon: 'database',
        component: InventoryStocksPage,
        allowedRoles: [Role.ADMIN],
      }, {
        path: paths.inventoryTransportLettersPath,
        name: locales.transport_letters,
        icon: 'file-text',
        component: InventoryTransportLettersPage,
        allowedRoles: [Role.ADMIN],
      },
      {
        path: paths.inventorySalesPath,
        name: locales.sales,
        icon: 'dollar',
        component: SalesPage,
        allowedRoles: [Role.ADMIN],
      }
    ],
  },
];

export const allowedMenuRoutes = (): MenuRoute[] => {
  const role = accountProvider.getRole();
  return appMenuRoutes.filter((route) => {
    if (role) {
      return route.allowedRoles.includes(role);
    } else {
      return false;
    }
  })
}

export const allowedSubMenuRoutes = (subMenus: MenuRoute[]): MenuRoute[] => {
  const role = accountProvider.getRole();
  return subMenus.filter((route) => {
    if (role) {
      return route.allowedRoles.includes(role);
    } else {
      return false;
    }
  })
}

class AppRoutes extends React.Component<RouteComponentProps, {}> {

  private locationListenerUnregisterCallback: UnregisterCallback;

  public componentDidMount() {
    this.locationListenerUnregisterCallback = this.props.history.listen(this.locationListener);
  }

  public componentWillUnmount() {
    this.locationListenerUnregisterCallback();
  }

  public render(): React.ReactNode {
    return accountProvider.isLoggedIn() ? this.renderRoutes() : this.renderLoginRoute();
  }

  private renderRoutes() {
    const admin = accountProvider.isAdmin();
    const sales = accountProvider.isSales();
    const maintenance = accountProvider.isMaintenance();
    const adminOrSales = admin || sales;
    const adminOrMaintenance = admin || maintenance;

    const menuRoutes: MenuRoute[] = [];
    allowedMenuRoutes()
      .forEach((route) => {
        menuRoutes.push(route);
        if (route.subMenus) {
          menuRoutes.push(...allowedSubMenuRoutes(route.subMenus))
        }
      });

    return (
      <Switch>
        {menuRoutes.map((route, idx) => (
          <Route key={idx} exact={true} path={route.path} component={route.component}/>
        ))}

        <Route path={paths.itemRentalHistoryPathTemplate} component={RentalsPage}/>
        <Route path={paths.clientRentalHistoryPathTemplate} component={RentalsPage}/>

        <Route exact={true} path={paths.loginPath} component={LoginPage}/>
        <Route path={paths.viewItemPathTemplate} component={ItemDetailsPage}/>
        {adminOrSales && <Route path={paths.createItemPath} component={CreateItemPage}/>}
        <Route path={paths.viewClientPathTemplate} component={ClientDetailsPage}/>
        {adminOrSales && <Route path={paths.createClientPath} component={CreateClientPage}/>}
        {admin && <Route path={paths.viewInventoryStockPathTemplate} component={InventoryStockDetailsPage}/>}
        {admin && <Route path={paths.createInventoryStockItemPathTemplate} component={CreateInventoryStockItemPage}/>}
        {admin &&
            <Route exact={true} path={paths.inventoryTransportLettersPath} component={InventoryTransportLettersPage}/>}
        {admin &&
            <Route path={paths.createInventoryTransportLetterPath} component={CreateInventoryTransportLetterPage}/>}
        {admin && <Route path={paths.viewInventoryTransportLetterPathTemplate}
                         component={InventoryTransportLetterDetailsPage}/>}

        <Route path={paths.createMaintenanceHistoryItemPathBase} component={CreateMaintenanceHistoryPage}/>
        <Route path={paths.viewMaintenanceHistoryItemPathTemplate} component={MaintenanceHistoryDetailsPage}/>

        {adminOrSales && <Route path={paths.sendRentalChecklistPathTemplate} component={SendRentalChecklistsPage}/>}
        {adminOrSales &&
            <Route path={paths.sendReturnalChecklistPathTemplate} component={SendReturnalChecklistsPage}/>}
        {adminOrSales && <Route path={paths.sendRentalDocumentsPathTemplate} component={SendRentalDocumentsPage}/>}
        {adminOrSales &&
            <Route path={paths.sendReturnalDocumentsPathTemplate} component={SendReturnalDocumentsPage}/>}

        {adminOrSales && <Route path={paths.createRentalPath} component={CreateRentalPage}/>}
        <Route path={paths.viewRentalPathTemplate} component={RentalDetailsPage}/>
        {adminOrSales && <Route path={paths.createReturnalPath} component={CreateReturnPage}/>}
        <Route path={paths.viewReturnalPathTemplate} component={ReturnDetailsPage}/>
        {admin && <Route path={paths.clientRevenueSummaryPathTemplate} component={ClientRevenueSummaryPage}/>}
        {adminOrSales && <Route path={paths.clientSummaryPathTemplate} component={ClientSummaryPage}/>}
        {adminOrSales && <Route path={paths.clientCalendarPathTemplate} component={ClientCalendarPage}/>}

        {admin && <Route path={paths.createIncomingInvoicePath} component={CreateIncomingInvoicePage}/>}
        {admin && <Route path={paths.viewIncomingInvoicePathTemplate} component={IncomingInvoiceDetailsPage}/>}

        {adminOrSales && <Route path={paths.createEventPath} component={CreateEventPage}/>}
        {adminOrSales && <Route path={paths.viewEventPathTemplate} component={EventDetailsPage}/>}

        {adminOrMaintenance &&
            <Route path={paths.createChecklistPathTemplate} component={CreateChecklistPage}/>
        }
        <Route path={paths.viewChecklistPathTemplate} component={ChecklistDetailsPage}/>

        {admin && <Route path={paths.createInventorySalePath} component={CreateSalePage}/>}
        {admin && <Route path={paths.viewInventorySalePathTemplate} component={SaleDetailsPage}/>}

        {admin && <Route path={paths.createInvoicePath} component={CreateInvoicePage}/>}
        {admin && <Route path={paths.clientInvoicesPathTemplate} component={ClientInvoicesPage}/>}
        {admin && <Route path={paths.viewInvoicePathTemplate} component={InvoiceDetailsPage}/>}

        <Route component={Page404}/>

      </Switch>
    )
      ;
  }

  private renderLoginRoute() {
    return (
      <Switch>
        <Route component={LoginPage}/>
      </Switch>
    );
  }

  private locationListener: LocationListener = (location: Location, _: Action) => {
    if (!accountProvider.isLoggedIn() && location.pathname !== paths.loginPath) {
      this.props.history.replace(paths.loginPath);
    }
  };
}

export default withRouter(AppRoutes);



// WEBPACK FOOTER //
// ./src/app/AppRoutes.tsx